import React from "react";
import styles from "./CustomCaoursel.module.scss";

interface CarouselCardProps {
  imgSrc?: string;
  text: string;
  subText?: string;
}

const CarouselCard: React.FC<CarouselCardProps> = ({
  imgSrc,
  text,
  subText,
}) => {
  return (
    <div
      className={`${styles.brandImages} d-flex justify-content-center align-items-center`}
    >
      {imgSrc && (
        <img
          src={imgSrc}
          className={`${styles.imgSrc} d-block`}
          alt={`Partner Logo`}
        />
      )}
      {text && (
        <p
          className={`para text-center mb-0 fw-bold ${styles.caourselCardText}`}
        >
          {text}
        </p>
      )}
    </div>
  );
};

export default CarouselCard;
